import { Row } from "@commonlibs";
import clsx from "clsx";
import BackIcon from "ui/common/icons/BackIcon";
import MenuIcon from "ui/common/icons/MenuIcon";
import SupportButtons from "../../input/SupportButtons/SupportButtons";
import { HeaderIcon, HeaderRoot } from "./Header.styles";
import { HeaderProps, LeftHeaderElement, LeftType, RightHeaderElement, RightType } from "./Header.types";
import { CloseCircleIcon } from "ui/common/icons";

const LEFT_HEADER_ELEMENTS: LeftHeaderElement = {
    menu: MenuIcon,
    back: BackIcon,
    close: CloseCircleIcon,
};

function rightHeaderElements(rightColor?: string): RightHeaderElement {
    return {
        support: <SupportButtons color={rightColor || "white"} />,
    };
}

const HeaderFallback = (): JSX.Element => <div></div>;

const Header = ({
    left,
    leftColor,
    center,
    right,
    rightColor,
    className,
    onLeftClick,
    onRightClick,
    ...rest
}: HeaderProps): JSX.Element => {
    const LeftElement = LEFT_HEADER_ELEMENTS[left as LeftType];

    return (
        <HeaderRoot className={clsx("header", className)} {...rest}>
            <Row flex={1 / 6}>
                {LeftElement ? <HeaderIcon color={leftColor} as={LeftElement} onClick={onLeftClick} /> : <HeaderFallback />}
            </Row>
            <Row flex={1 / 1.5} justifyContent="center">
                {center}
            </Row>
            <Row flex={1 / 6} justifyContent="right" onClick={onRightClick}>
                {rightHeaderElements(rightColor)[right as RightType] || <HeaderFallback />}
            </Row>
        </HeaderRoot>
    );
};

export default Header;
